module.exports = __webpack_public_path__ + "static/media/kv-zh-Hans.2cd2742b.jpg";